export default __webpack_public_path__ + "static/logo_LaJornadaVeracruz-02e4a5ad7dc5cc63aecfe62918c07bd7.svg";